import React from 'react'
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from './navbar';
import Footer from './footer';

export default function PrivacyPage() {

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    
      const schemaData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Toodhu Privacy Policy",
        "url": "https://toodhu.com/privacy",
        "description": "Read Toodhu's Privacy Policy to understand how we collect, use, and protect your personal data. Stay informed about your privacy rights today.",
        "inLanguage": "en",
        "isPartOf": {
          "@type": "WebSite",
          "name": "Toodhu",
          "url": "https://toodhu.com"
        },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://toodhu.com"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Privacy Policy",
              "item": "https://toodhu.com/privacy"
            }
          ]
        },
        "about": {
          "@type": "WebPage",
          "name": "Privacy Policy",
          "description": "This Privacy Policy outlines how Toodhu collects, uses, and protects personal data to ensure transparency and compliance with user privacy rights.",
          "provider": {
            "@type": "Organization",
            "name": "Toodhu",
            "url": "https://toodhu.com"
          }
        }
      };

  return (

<>
<Helmet>

<title>Toodhu Privacy Policy | Learn How We Protect Your Data</title>
<meta charset="utf-8"/>
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1" />
<meta name="description" content="Read Toodhu's Privacy Policy to understand how we collect, use, and protect your personal data. Stay informed about your privacy rights today."/>
<meta name="keywords" content="Toodhu privacy policy, Data protection, Privacy rights"/>
<link rel="canonical" href="https://toodhu.com/privacy-policy" />
<meta name="robots" content="index,follow"/>
<meta property="og:title" content="Toodhu Privacy Policy | Learn How We Protect Your Data"/>
<meta property="og:site_name" content="Toodhu"/>
<meta property="og:url" content="https://toodhu.com/privacy-policy"/>
<meta property="og:description" content="Read Toodhu's Privacy Policy to understand how we collect, use, and protect your personal data. Stay informed about your privacy rights today."/>
<meta property="og:type" content="website"/>
<meta property="og:image" content=""/>
<meta name="twitter:card" content="summary_large_image"/>
<meta name="twitter:site" content="https://toodhu.com/privacy-policy"/>
<meta name="twitter:title" content="Toodhu Privacy Policy | Learn How We Protect Your Data"/>
<meta name="twitter:description" content="Read Toodhu's Privacy Policy to understand how we collect, use, and protect your personal data. Stay informed about your privacy rights today."/>
<meta name="twitter:image" content=""></meta>

<script type="application/ld+json">{JSON.stringify(schemaData)}</script>

</Helmet>

    <div>
    
    <div>
      <Navbar/>
    </div>

       <section class="section-30 section-sm-40 section-md-66 section-lg-bottom-90 bg-gray-dark page-title-wrap">
        <div class="shell">
            <div class="page-title">
                <h2 className='text-center mt-[41px]'></h2>
            </div>
        </div>
    </section>

    <section class="project-details mt-[111px]">
        <div class="container">
            <div class="project-heading">
                <div class="row">
                    <div class="col-12 col-lg-12 mx-auto mt-4 " >
                        <h1 class="project-title text-center">Privacy Policy</h1>
                    </div>
                </div>
            </div>
            <div class="main-area">
                <div class="row">
                    <div class="col-12 col-lg-12 mx-auto ">
                    <p class="project-text">
                            At Toodhu, your privacy is of utmost importance to us. We are dedicated to ensuring the 
                  security and confidentiality of your personal information and sensitive system data. This Privacy Policy explains how we collect, use,
                   share, and protect your data, ensuring transparency and compliance with applicable laws.
                
             
                        </p>
                        <h4>Data Protection and Security</h4>
                        <p class="project-text">
                            We take extensive measures to protect your personal information, employing physical, electronic, and procedural safeguards in line with legal standards. This includes training our staff to handle personal data responsibly and requiring any third-party service providers to adhere to strict confidentiality obligations. Your data is never stored as plain text and is encrypted for enhanced security. However, you must also take precautions by safeguarding your passwords and login details to prevent unauthorized access.
             
                        </p>
                        <h4>Information Collection and Usage</h4>
                        <p class="project-text">
                        Toodhu collects personal information in a variety of ways, including when you visit our website, create an account, subscribe to our services, or contact us. The types of data we collect include:
             
                        </p>
                        <ul class="list steps">
                            <li class="list-item step"><i class="fas fa-dot-circle icon"></i><span class="spnlistitem">Personal Information: Name, email address, contact details, and other information provided during account registration or communication with us.</span></li>
                            <li class="list-item step"><i class="fas fa-dot-circle icon"></i><span class="spnlistitem">System Information: Data related to your interactions with our website or services, such as IP addresses, device types, and usage patterns. </span></li>
                        </ul>
                        <p class="project-text">
                            We collect and use this information to:
             
                        </p>
                        <ul class="list steps">
                            <li class="list-item step"><i class="fas fa-dot-circle icon"></i><span class="spnlistitem">Provide you with the services you’ve requested.</span></li>
                            <li class="list-item step"><i class="fas fa-dot-circle icon"></i><span class="spnlistitem">Improve our offerings and customer service. </span></li>
                            <li class="list-item step"><i class="fas fa-dot-circle icon"></i><span class="spnlistitem">Communicate important updates, such as changes to our services, or send promotional material (if you’ve opted in). </span></li>
                        </ul>

                        <h4>Sharing of Information</h4>
                        <p class="project-text">
                        Toodhu does not sell or disclose your personal information to unaffiliated third parties for marketing purposes. We only share your information under the following circumstances:
                        </p>
                        <ul class="list steps">
                            <li class="list-item step"><i class="fas fa-dot-circle icon"></i><span class="spnlistitem">Service Fulfillment: We may share your data with trusted third-party providers who perform services on our behalf, such as payment processors or technical support teams. These providers are contractually obligated to protect your data and use it only for the agreed-upon purposes.</span></li>
                            <li class="list-item step"><i class="fas fa-dot-circle icon"></i><span class="spnlistitem">With Your Consent: In cases where we need to share your information with third parties for other purposes, we will request your explicit consent. </span></li>
                            <li class="list-item step"><i class="fas fa-dot-circle icon"></i><span class="spnlistitem">Legal Requirements: We may disclose your information to comply with legal obligations, court orders, or other government requests. This includes sharing data to protect the rights, property, or safety of Toodhu, our clients, or the public. </span></li>
                        </ul>

                        <h4>Third-Party Links</h4>
                        <p class="project-text">
                            Our services may include links to external websites or services operated by third parties. While we provide these links for your convenience, Toodhu is not responsible for the privacy practices or content of these external sites. We recommend that you review the privacy policies of any third-party sites you visit to understand how they handle your personal information.
                        </p>
                        <h4>Legal Disclosures</h4>
                        <p class="project-text">
                        Toodhu reserves the right to disclose personal data if required by law or in response to valid legal processes. This includes situations where we need to enforce our agreements or protect our rights and the rights of others, such as in cases of fraud prevention or security breaches.
                        </p>
                        <h4>Business Transactions</h4>
                        <p class="project-text">
                            In the event that Toodhu is involved in a merger, acquisition, or sale of assets, your personal information may be disclosed to the prospective or actual buyers as part of the business transaction. We will ensure that appropriate measures are taken to protect your data during such transitions, though we cannot guarantee that our Privacy Policy will remain unchanged in the event of a corporate restructuring.
                        </p>
                        <h4>Email Privacy</h4>
                        <p class="project-text">
                            Why You Receive Emails from Us
                        </p>
                        <p class="project-text">
                            We comply with the CAN-SPAM Act in the United States, which governs how companies can send emails. You may receive emails from us because:
                        </p>
                        <ul class="list steps">
                            <li class="list-item step"><i class="fas fa-dot-circle icon"></i><span class="spnlistitem">You have provided your email address to receive updates or information.</span></li>
                            <li class="list-item step"><i class="fas fa-dot-circle icon"></i><span class="spnlistitem">You have registered for our services or have an ongoing relationship with us or our marketing partners. </span></li>

                        </ul>
                        <p class="project-text">
                            If you believe you’ve received unwanted or unsolicited emails, please forward them to us at support@Toodhu.io for review.
                        </p>
                        <h4>How to Unsubscribe</h4>
                        <p class="project-text">
                            If you no longer wish to receive our marketing emails, we make it easy for you to unsubscribe by following the link provided in each email. You can also contact us directly at support@Toodhu.io.
                        </p>

                        <h4>Security of Data</h4>
                        <p class="project-text">
                            We are committed to protecting your personal data against unauthorized access, alteration, disclosure, or destruction. We employ industry-standard security technologies, such as encryption and secure servers, to safeguard your information.
                        </p>
                        <h4>Sharing and Usage of Data</h4>
                        <p class="project-text">
                            We will never sell or rent your personal information for marketing purposes without your explicit consent. Access to your data is limited to authorized employees who manage this information to communicate with you or send emails based on your request for information.
                        </p>
                        <h4>Web Beacons</h4>
                        <p class="project-text">
                            Our emails may contain web beacons, small electronic files that allow us to track email open rates and other metrics. Web beacons help us improve the relevance and effectiveness of our communications. If you prefer not to receive web beacons, you can disable HTML images in your email settings or opt to receive text-only emails.
                        </p>
                        <h4>Data Processing for EU/UK Residents</h4>
                        <p class="project-text" >
                            Notice to EU and UK Residents
                        </p>
                        <p class="project-text">
                            If you are a resident of the European Union or the United Kingdom, the collection and processing of your personal data are necessary for us to provide our services, prevent fraud, and maintain your account. We retain personal and payment data for at least two years for legal compliance. If you cancel your subscription, we will retain your data for 90 days and securely delete it unless otherwise requested.
                            </p>
                        <p class="project-text">
You have the right to:
                        </p>
                        <ul class="list steps">
                            <li class="list-item step"><i class="fas fa-dot-circle icon"></i><span class="spnlistitem">Request a Copy of Your Data: You can ask for a copy of the personal data we’ve collected.</span></li>                           
	                        <li class="list-item step"><i class="fas fa-dot-circle icon"></i><span class="spnlistitem">Erase Your Data: You can request deletion of your data once it is no longer required by Toodhu.</span></li>
                            <li class="list-item step"><i class="fas fa-dot-circle icon"></i><span class="spnlistitem">Opt-Out of Marketing: You can withdraw your consent from receiving targeted marketing emails at any time by clicking “Unsubscribe” or “Manage Preferences” in any email or contacting support@Toodhu.io.</span></li>
                            <li class="list-item step"><i class="fas fa-dot-circle icon"></i><span class="spnlistitem">File a Complaint: If you have concerns about how your data is processed, you can file a complaint with a supervisory authority.</span></li>
                        </ul>
                        <h4>Cookies and Tracking Technologies</h4>
                        <p class="project-text">
                            When you use our website, we may collect information using cookies and similar technologies. These cookies allow us to track your activities and connect them with your personal information, such as your email address. This helps us enhance your user experience and send relevant communications. You can opt out by adjusting your browser settings or clicking "Manage Preferences" or "Unsubscribe" in our emails.
                        </p>
                        <h4>Third-Party Integrations</h4>
                        <p class="project-text">
                        Toodhu integrates with various third-party services such as Google, Microsoft, Shopify and few other tools to provide enhanced functionality. As part of this integration, we may access user data, such as email addresses or account information, to deliver these services. We do not use this data beyond the scope of improving our platform or providing requested services. Third-party data is handled in compliance with privacy laws and the policies of the respective service providers.
                        </p>
                        <h4>Retention and Deletion of Data</h4>
                        <p class="project-text">
                            If you disconnect your Toodhu account from third-party services, we will immediately delete any associated user data from our systems. Additionally, if you cancel your Toodhu subscription, we will retain your data for 90 days before securely deleting it unless otherwise requested. You may request the deletion of any third-party data at any time by contacting support@Toodhu.io.
                        </p>
                        <h4>Changes to the Privacy Policy</h4>
                        <p class="project-text">
                            From time to time, we may update this Privacy Policy to reflect changes in our practices or legal requirements. We will notify you of any significant changes. The effective date at the top of this policy indicates when it was last revised.
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </section>

    <div>
        <Footer/>
    </div>
    </div>

    </>


  )
}
